// const OneDayMs = 1000 * 60 * 60 * 24
// import { isString } from 'lodash-es'
import { dayjsInit } from '../time'

const makeLeft = (slug) => {
  const arr = slug.split('.')
  if (arr.length > 1) {
    return {
      slug,
    }
  }
  return {
    slug,
  }
}

// eslint-disable-next-line no-unused-vars
function operatorCreater(queryType, operator) {
  return (slug, nodeTemplateId, value, tbId) => {
    const props = {}
    if (slug === 'objectId') {
      props.useTableDataField = true
      props.fieldName = 'id'
    }
    // let rightValue = value
    // if (operator === 'like') {
    //   rightValue = `*${value}*`
    // }
    return {
      queryType,
      // queryOperate: {
      //   nodeTemplateId,
      //   slug,
      //   operator,
      //   rightValue: specified === undefined ? value : specified,
      //   ...props,
      // },
      tbId,
      yacQueryOperate: {
        operator,
        left: makeLeft(slug),
        right: {
          value:
            operator === 'in' || operator === 'reverse_contain'
              ? [value]
              : value,
        },
      },
    }
  }
}

// eslint-disable-next-line no-unused-vars
function dateOperatorCreater(operatorCreaterFunc) {
  return (slug, nodeTemplateId, value) => {
    const stamp = new Date(value).getTime()
    return operatorCreaterFunc(slug, nodeTemplateId, stamp)
  }
}
// eslint-disable-next-line no-unused-vars
function booleanOperatorCreater(operatorCreaterFunc) {
  return (slug, nodeTemplateId, value) => {
    let real
    switch (value) {
      case false:
        real = 2
        break
      case true:
        real = 1
        break
      default:
        real = 0
        break
    }
    return operatorCreaterFunc(slug, nodeTemplateId, real)
  }
}

function queryTypeLabelsCreater(types) {
  const o = {}
  types.forEach((p) => {
    o[p[1]] = {
      label: p[0],
      value: p[1],
    }
  })
  return o
}

/**
 * 所有的操作模板
 */
const allOperatorTemplates = {
  equal: operatorCreater('just', 'equal'),
  like: operatorCreater('just', 'like'),
  contain: operatorCreater('just', 'contain'),
  reverse_contain: operatorCreater('just', 'reverse_contain'),
  notEqual: operatorCreater('not', 'equal'),
  isNull: operatorCreater('just', 'equal', null),
  notNull: operatorCreater('not', 'equal', null),
  inList: operatorCreater('just', 'in'),
  notInList: operatorCreater('not', 'in'),
  containString: operatorCreater('just', 'like'),
  notContainString: operatorCreater('not', 'like'),
  containArray: operatorCreater('just', 'contain'),
  notContainArray: operatorCreater('not', 'contain'),
  containedByArray: operatorCreater('just', 'reverse_contain'),
  gt: operatorCreater('just', 'gt'),
  lt: operatorCreater('just', 'lt'),
  gte: operatorCreater('just', 'gte'),
  lte: operatorCreater('just', 'lte'),
  lnglat: operatorCreater('just', 'lnglat'),
  geo: operatorCreater('just', 'geo_intersects'),
  /**
   * dayEqual的查询需要生成一个区间查询
   * @param {*} param0
   * @param {*} value 日期字符串
   * @returns
   */
  dayEqual: (slug, nodeTemplateId, value, tbId) => {
    // const stamp = new Date(value).getTime()
    // const stampBegin = new Date(new Date(value).toLocaleDateString()).getTime()
    // const stampEnd =
    //   new Date(new Date(value).toLocaleDateString()).getTime() +
    //   24 * 60 * 60 * 1000 -
    //   1
    // const currentValue = new Date(
    //   isString(value) ? value.replace(/-/g, '/').replace('T', ' ') : value
    // )
    // const _currentValue = new Date(
    //   isString(value) ? value.replace(/-/g, '/').replace('T', ' ') : value
    // )
    const stampBegin =
      dayjsInit(
        dayjsInit(value).set('date', dayjsInit(value).date() - 1)
      ).valueOf() +
      24 * 60 * 60 * 1000 -
      1

    const stampEnd = dayjsInit(
      dayjsInit(value).set('date', dayjsInit(value).date() + 1)
    ).valueOf()

    return {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'gt',
            right: { value: stampBegin },
          },
        },
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'lt',
            right: { value: stampEnd },
          },
        },
      ],
    }
  },
  dayRange: (slug, nodeTemplateId, value, tbId) => {
    // const stamp = new Date(value).getTime()
    // const stampBegin = new Date(new Date(value).toLocaleDateString()).getTime()
    // const stampEnd =
    //   new Date(new Date(value).toLocaleDateString()).getTime() +
    //   24 * 60 * 60 * 1000 -
    //   1
    console.log('range====', value)
    const { startDate, endDate } = value
    if (!startDate || !endDate) return {}
    const stampBegin =
      startDate instanceof Date ? startDate.getTime() : startDate
    const stampEnd = endDate instanceof Date ? endDate.getTime() : endDate
    return {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'gte',
            right: { value: stampBegin },
          },
        },
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'lte',
            right: { value: stampEnd },
          },
        },
      ],
    }
  },
  dayGt: (slug, nodeTemplateId, value, tbId) => {
    const stampEnd = dayjsInit(value).valueOf() + 24 * 60 * 60 * 1000 - 1
    // const stampEnd =
    //   new Date(new Date(value).toLocaleDateString()).getTime() +
    //   24 * 60 * 60 * 1000 -
    //   1
    return {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'gt',
            right: {
              value: stampEnd,
            },
          },
        },
      ],
    }
  },
  dayGte: (slug, nodeTemplateId, value, tbId) => {
    const stampBegin = dayjsInit(value).valueOf()
    // const stampBegin = new Date(new Date(value).toLocaleDateString()).getTime()
    return {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'gte',
            right: {
              value: stampBegin,
            },
          },
        },
      ],
    }
  },
  dayLt: (slug, nodeTemplateId, value, tbId) => {
    const stampBegin = dayjsInit(value).valueOf()
    // const stampBegin = new Date(new Date(value).toLocaleDateString()).getTime()
    return {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'lt',
            right: {
              value: stampBegin,
            },
          },
        },
      ],
    }
  },
  dayLte: (slug, nodeTemplateId, value, tbId) => {
    const stampEnd = dayjsInit(value).valueOf() + 24 * 60 * 60 * 1000 - 1
    // const stampEnd =
    //   new Date(new Date(value).toLocaleDateString()).getTime() +
    //   24 * 60 * 60 * 1000 -
    //   1
    return {
      queryType: 'and',
      childQueries: [
        {
          queryType: 'just',
          tbId,
          yacQueryOperate: {
            nodeTemplateId,
            left: makeLeft(slug),
            operator: 'lte',
            right: {
              value: stampEnd,
            },
          },
        },
      ],
    }
  },
  // dayGt: dateOperatorCreater(operatorCreater('just', 'gt')),
  // dayGte: dateOperatorCreater(operatorCreater('just', 'gte')),
  // dayLt: dateOperatorCreater(operatorCreater('just', 'lt')),
  // dayLte: dateOperatorCreater(operatorCreater('just', 'lte')),
  /**
   * boole类型的null true false 分别对应
   */
  // boolEqual: booleanOperatorCreater(operatorCreater('just', 'equal')),
  // boolIsNull: booleanOperatorCreater(operatorCreater('just', 'equal')),
  // boolNotNull: booleanOperatorCreater(operatorCreater('not', 'equal')),
  true: operatorCreater('just', 'equal', true),
  false: operatorCreater('just', 'equal', false),
}

function arrrayToQueryTypes(types) {
  return Object.freeze(
    types.map((p) => {
      return {
        label: p[0],
        value: p[1],
      }
    })
  )
}

/**
 * number类型可用的操作类型
 */
const compareQueryTypes = arrrayToQueryTypes([
  ['=', 'equal'],
  // ['≠', 'notEqual'],
  ['>', 'gt'],
  ['≥', 'gte'],
  ['<', 'lt'],
  ['≤', 'lte'],
])
/**
 * date类型可用的操作类型
 */
const dateQueryTypes = arrrayToQueryTypes([
  ['等于', 'dayEqual'],
  ['晚于', 'dayGt'],
  ['不早于', 'dayGte'],
  ['早于', 'dayLt'],
  ['不晚于', 'dayLte'],
  ['介于', 'dayRange'],
])
/**
 * rangeDate类型可用的操作类型
 */
const rangeDateQueryTypes = arrrayToQueryTypes([['介于', 'dayRange']])
const booleanQueryTypes = arrrayToQueryTypes([
  ['等于', 'boolEqual'],
  ['为空', 'boolIsNull'],
  ['不为空', 'boolNotNull'],
])
/**
 * 普通的操作类型
 */
const normalQueryTypes = queryTypeLabelsCreater([
  ['等于', 'equal'],
  ['不等于', 'notEqual'],
  ['为空', 'isNull'],
  ['不为空', 'notNull'],
  ['属于', 'inList'],
  ['不在列表中', 'notInList'],
  // 字符串的包含不包含操作
  ['包含', 'containString'],
  ['不包含', 'notContainString'],
  // 数组类的包含不包含
  ['包含', 'containArray'],
  ['不包含', 'notContainArray'],
  ['被包含', 'containedByArray'],
  // 布尔类型
  ['是', 'true'],
  ['否', 'false'],
])

/**
 * 判空的操作类型
 */
const judgeNullQueryTypes = queryTypeLabelsCreater([['判空', 'judgeNull']])

/**
 * 从normal查询类型中查找给定的查询类型
 * @param {} types
 * @returns
 */
function normalQueryTypesCreater(types) {
  return Object.freeze(types.map((p) => normalQueryTypes[p]))
}

/**
 * 选择类型支持等于、不等于、包含、不包含、被包含、为空，不为空查询
 */
const orgFilterSpec = {
  queryTypes: normalQueryTypesCreater([
    'equal',
    'inList',
    // 'notEqual',
    'containArray',
    // 'notContainArray',
    'containedByArray',
    // 'isNull',
    // 'notNull',
  ]),
}

/**
 * 选择类型支持等于、不等于、包含、不包含、被包含、为空，不为空查询
 */
const selectFilterSpec = {
  queryTypes: normalQueryTypesCreater([
    // 'equal',
    // 'notEqual',
    'containArray',
    // 'notContainArray',
    'containedByArray',
    'isNull',
    'notNull',
  ]),
}

/**
 * 仅支持为空，不为空查询
 * */
const justFilterSpec = {
  queryTypes: normalQueryTypesCreater(['isNull', 'notNull']),
}
/**
 * 数字类型比较查询
 */
const compareFilterSpec = {
  queryTypes: compareQueryTypes,
}
/**
 * 时间比较类型
 */
const dateFilterSpec = {
  queryTypes: dateQueryTypes,
}
/**
 * 范围时间比较类型
 */
const rangeDateFilterSpec = {
  queryTypes: rangeDateQueryTypes,
}
/**
 * 时间比较类型
 */
const booleanFilterSpec = {
  queryTypes: booleanQueryTypes,
}
/**
 * 外连接表类型支持等于，不等于、在列表中、不在列表中、为空、不为空查询
 *  */
const outTableFilterSpec = {
  queryTypes: [
    'equal',
    // 'notEqual',
    'inList',
    // 'notInList',
    // 'isNull',
    // 'notNull',
  ].map((p) => normalQueryTypes[p]),
}

export {
  allOperatorTemplates,
  compareQueryTypes,
  normalQueryTypes,
  judgeNullQueryTypes,
  orgFilterSpec,
  selectFilterSpec,
  justFilterSpec,
  compareFilterSpec,
  outTableFilterSpec,
  dateFilterSpec,
  booleanFilterSpec,
  rangeDateFilterSpec,
}
